import { watchTips } from "@/mocks/homeContent";

export default function WatchTipsSection() {
  return (
    <section id="tips" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="grid grid-cols-1 lg:grid-cols-12">
            <div className="bg-foreground-950 p-6 text-background-50 md:p-8 lg:col-span-4">
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-100">
                <span className="flex h-3.5 w-3.5 items-center justify-center text-accent-300">
                  <i className="ri-lightbulb-line"></i>
                </span>
                观看提示
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight md:text-3xl">
                让观看更顺畅的几点建议
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-200">
                在进入在线观看流程之前，先花一点时间确认环境与顺序，能显著减少中途打断，让叙事体验更连贯。
              </p>
            </div>

            <div className="lg:col-span-8">
              <div className="grid grid-cols-1 gap-px bg-background-200 sm:grid-cols-3">
                {watchTips.map((tip) => (
                  <div key={tip.title} className="bg-background-50 p-6 md:p-8">
                    <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-xl text-secondary-700">
                      <i className={tip.icon}></i>
                    </span>
                    <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                      {tip.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                      {tip.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}